var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mineshop-wrap"},[_c('div',{},[_c('van-cell',{attrs:{"title":"核销统计","is-link":"","to":"/writeoffstatistics"}}),_c('van-cell',{attrs:{"title":"每日核销","is-link":"","to":"/writeoffday"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }